
import type { PropType } from 'vue'
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// realisations
import { rpp } from '@/core/realisations/rpp.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        title: {
            type: String,
            default: 'Массовое подтверждение'
        },
        paymentBySupplierIds: {
            type: Array as PropType<Array<number>>,
            default: () => []
        },
        newStatus: {
            type: String as PropType<'confirmed' | 'denied'>,
            default: 'confirmed'
        }
    },
    emits: ['cancel', 'success'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            comment: null as string | null
        })

        const onConfirm = async () => {
            try {
                state.is_loading = true

                await rpp.submitRpp({
                    statusCode: props.newStatus,
                    comment: state.comment,
                    paymentBySupplierIds: props.paymentBySupplierIds
                })

                notifications.notify({ type: 'success', title: props.paymentBySupplierIds.length > 1 ? 'Статусы успешно изменены' : 'Статус успешно изменен' })
                emit('success')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: props.paymentBySupplierIds.length > 1 ? 'При массовой смене статуса произошла ошибка' : 'При смене статуса произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        const onCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        return {
            state,
            onConfirm,
            onCancel,
        }
    },
})
